import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
// const DdHacchuKensakuTextBox = () => import('@/components/DdHacchuKensakuTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'PloHacchuList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDateRangeBox,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    rows: [],
    conditions: {
      hacchuEigyoshoCd: '',
      hacchuStartYmdString: '',
      hacchuEndYmdString: '',
      nyuryokuTantoshaCd: '',
      hacchusakiCd: '',
      sagyoYoteiStartYmdString: '',
      sagyoYoteiEndYmdString: '',
      chumonNo: '',
      ninushiCd: '',
      hatsuchiCd: '',
      oroshisakiCd: '',
      chakuchiCd: '',
      hacchuStatus: '',
      shiharaiStatus: ''
    },
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.hacchuYmd = filter.dateFormatter(elem.hacchuYmd)
        elem.hacchusakiKbnDisp = elem.hacchusakiKbn === '1' ? '傭車先' : elem.hacchusakiKbn === '2' ? '仕入先' : ''
        elem.hacchuEigyoshoDisp = elem.hacchuEigyoshoCd ? elem.hacchuEigyoshoCd + ' : ' + elem.hacchuEigyoshoNm : ''
        elem.hacchusakiDisp = elem.hacchusakiCd ? elem.hacchusakiCd + ' : ' + elem.hacchusakiNm : ''
        elem.shiharaiTomeFlgDisp = elem.shiharaiTomeFlg ? '支払対象外' : '支払対象'
        elem.ikkatsuShiharaiFlgDisp = elem.ikkatsuShiharaiFlg ? '一括支払' : '個別支払'
        elem.shiharaiYoteiYmd = elem.shiharaiYoteiYmd ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
        elem.unchinKakuteiFlgDisp = elem.unchinKakuteiFlg ? '確定' : '未確定'
        elem.shiharaiZumiFlgDisp = elem.shiharaiZumiFlg ? '支払済' : '未支払'
        elem.shiharaiKingaku = filter.numericFormatter(elem.shiharaiKingaku)
        elem.hacchuMeisaiKingaku = filter.numericFormatter(elem.hacchuMeisaiKingaku)
        // elem.sagyoYoteiYmd = elem.sagyoYoteiYmd ? filter.dateFormatter(elem.sagyoYoteiYmd) : ''
        elem.ninushiDisp = elem.ninushiCd ? elem.ninushiCd + ' : ' + elem.ninushiNm : ''
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : ''
        elem.hatsuchiYmd = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHms = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : ''
        elem.chakuchiYmd = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHms = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.yoteiSagyoJikan = elem.yoteiSagyoJikan ? filter.minToTimeFormatter(elem.yoteiSagyoJikan) : ''
        elem.warimashiTaishoJikan = elem.warimashiTaishoJikan ? filter.minToTimeFormatter(elem.warimashiTaishoJikan) : ''
        elem.warimashiJikanTanka = elem.warimashiJikanTanka ? filter.numericFormatter(elem.warimashiJikanTanka) : ''
        elem.yoteiSokoKyori = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) : ''
        elem.warimashiTaishoKyori = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) : ''
        elem.warimashiKyoriTanka = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.hacchuInsDate = filter.dateFormatter(elem.hacchuInsDate)
        elem.hacchuInsUserDisp = elem.hacchuInsUserCd ? elem.hacchuInsUserCd + ' : ' + elem.hacchuInsUserNm : ''
        elem.hacchuUpdDate = filter.dateFormatter(elem.hacchuUpdDate)
        elem.hacchuUpdUserDisp = elem.hacchuUpdUserCd ? elem.hacchuUpdUserCd + ' : ' + elem.hacchuUpdUserNm : ''

        return elem
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      // const self = this
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
        // 他営業所捜査フラグを考慮する場合は↓を適用
        // return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01' && (self.anotherEigyoshoCtrlFlg === true || (self.anotherEigyoshoCtrlFlg === false && elem.eigyoshoCd === self.usersEigyoshoCd))
      })
    },
    filteredHacchuEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredNyuryokuTantoshaList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.eigyoshoJininList.map((elem) => {
        elem.jomuFlg = elem.jomuFlg ? '乗務員' : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01' &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && (elem.hacchusakiFlg || elem.yoshasakiFlg)
      })
    },
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    filteredMstHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    deleteButtonDisp () {
      if (this.modeKengen === 2) {
        return true
      } else {
        return false
      }
    },
    isDeleteButtonDisabled () {
      if (this.modeKengen !== 2) {
        return true
      }
      if (this.selected.length > 0) {
        return false
      }
      return true
    },
    createButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthacchakuchi'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('VwCHacchuIchiran.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '作業進捗', value: 'sagyoStatusNm' },
              { text: '発注番号', value: 'hacchuNo' },
              { text: '発注日', value: 'hacchuYmd', align: 'center' },
              { text: '発注営業所', value: 'hacchuEigyoshoDisp' },
              { text: '注文番号', value: 'chumonNo' },
              { text: '発注先区分', value: 'hacchusakiKbnDisp' },
              { text: '発注先', value: 'hacchusakiDisp' },
              { text: '支払止', value: 'shiharaiTomeFlgDisp' },
              { text: '支払区分', value: 'ikkatsuShiharaiFlgDisp' },
              { text: '支払予定日', value: 'shiharaiYoteiYmd', align: 'center' },
              { text: '運賃確定状況', value: 'unchinKakuteiFlgDisp' },
              { text: '支払状況', value: 'shiharaiZumiFlgDisp', filterable: false },
              { text: '支払金額', value: 'shiharaiKingaku', align: 'right' },
              { text: '発注契約番号', value: 'hacchuKeiyakuNo', align: 'center' },
              { text: '発注明細番号', value: 'hacchuMeisaiNo' },
              { text: '発注明細金額', value: 'hacchuMeisaiKingaku', align: 'right', filterable: false },
              // { text: '作業希望日', value: 'sagyoYoteiYmd', align: 'center' },
              { text: '荷主', value: 'ninushiDisp' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発日付', value: 'hatsuchiYmd', align: 'center' },
              { text: '発時刻', value: 'hatsuchiHms', align: 'center' },
              { text: '発時刻備考', value: 'hatsuchiHmsBiko' },
              // { text: '卸先', value: 'oroshisakiDisp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着日付', value: 'chakuchiYmd', align: 'center' },
              { text: '着時刻', value: 'chakuchiHms', align: 'center' },
              { text: '着時刻備考', value: 'chakuchiHmsBiko' },
              { text: '予定作業時間', value: 'yoteiSagyoJikan', align: 'center' },
              { text: '割増対象時間', value: 'warimashiTaishoJikan', align: 'center' },
              { text: '割増時間単価', value: 'warimashiJikanTanka', align: 'right' },
              { text: '予定作業距離', value: 'yoteiSokoKyori', align: 'right' },
              { text: '割増対象距離', value: 'warimashiTaishoKyori', align: 'right' },
              { text: '割増距離単価', value: 'warimashiKyoriTanka', align: 'right' },
              { text: '登録日', value: 'hacchuInsDate' },
              { text: '登録者', value: 'hacchuInsUserDisp' },
              { text: '更新日', value: 'hacchuUpdDate' },
              { text: '更新者', value: 'hacchuUpdUserDisp' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            const d = new Date()
            self.conditions = {
              hacchuEigyoshoCd: !self.eigyoshoLockFlg ? self.userEigyoshoCd : '',
              hacchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              hacchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              nyuryokuTantoshaCd: '',
              hacchusakiCd: '',
              sagyoYoteiStartYmdString: '',
              sagyoYoteiEndYmdString: '',
              chumonNo: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              hacchuStatus: '99',
              shiharaiStatus: '99'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('VwCHacchuIchiran.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('VwCHacchuIchiran.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('VwCHacchuIchiran.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('VwCHacchuIchiran.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('VwCHacchuIchiran.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      // 選択状態初期化
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plod0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            hacchuStatus: self.conditions.hacchuStatus,
            shiharaiStatus: self.conditions.shiharaiStatus
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            const d = new Date()
            this.conditions = {
              hacchuEigyoshoCd: !self.eigyoshoLockFlg ? self.userEigyoshoCd : '',
              hacchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              hacchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              nyuryokuTantoshaCd: '',
              hacchusakiCd: '',
              sagyoYoteiStartYmdString: '',
              sagyoYoteiEndYmdString: '',
              chumonNo: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              hacchuStatus: '99',
              shiharaiStatus: '99'
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            this.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    selectItem: function (e, row) {
      // 更新対象のインデックスを取得
      var targetIdx = this.rows.findIndex(elem => elem.id === row.id)

      // フラグ更新
      this.rows[targetIdx].isSelected = e

      // DOM更新の発火
      this.rows.splice()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onDeleteButtonClick: function (e) {
      var isDelete = true
      const self = this
      // 削除可能チェック
      for (const r of this.selected) {
        if (r.sagyoStatus !== '02' || r.shiharaiZumiFlg) {
          isDelete = false
        }
      }

      // 削除処理実行
      if (isDelete) {
        const p = modals.showConfirm
        p('COMQ0003').then((ok) => {
          if (ok === false || ok === undefined) { return }

          this.Effects.loadStart()

          function deletePromise () {
            return new Promise(function (resolve) {
              var deleteTargetId = []
              self.selected.forEach((x) => {
                deleteTargetId.push(x.id)
              })
              self.HttpClient.delete(`/api/v1/TrHacchuKihon/MultipleDeleteWithChildren?id=${deleteTargetId.join(',')}`).then((data) => {
                resolve(data)
              })
            })
          }
          deletePromise().then(() => {
            console.log('complatePromise')
            self.Effects.loadComplete()
            modals.showSuccess('対象を削除しました。')
            // 再検索
            this.onSearchButtonClick()
          })
        })
      } else {
        modals.showError('計画済・作業完了・実績確認済み・支払済みの受注は削除できません。<br>対象を見直してください。')
      }
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      if (!this.conditions.hacchuEigyoshoCd && !this.conditions.hacchuStartYmdString && !this.conditions.hacchuEndYmdString && !this.conditions.nyuryokuTantoshaCd && !this.conditions.hacchusakiCd && !this.conditions.sagyoYoteiStartYmdString && !this.conditions.sagyoYoteiEndYmdString && !this.conditions.chumonNo && !this.conditions.ninushiCd && !this.conditions.hatsuchiCd && !this.conditions.oroshisakiCd && !this.conditions.chakuchiCd && this.conditions.hacchuStatus === '99' && this.conditions.shiharaiStatus === '99') {
        this.setInvalidSummaryMessage('COME0026')
        return false
      }
      if (this.conditions.hacchuStartYmdString && this.conditions.hacchuEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.hacchuStartYmdString, this.conditions.hacchuEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.hacchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.hacchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      if (this.conditions.sagyoYoteiStartYmdString && this.conditions.sagyoYoteiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.sagyoYoteiStartYmdString, this.conditions.sagyoYoteiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.sagyoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.sagyoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
